import React, { Component, Fragment } from "react";
import BannerImageURL from "../../logo/banner.png";
import envConfig from "../../environment-property/property.json";

class Banner extends Component {
  constructor(props) {
    super(props);
    this.state = {
      bannerVisible: envConfig.banner.showBanner,
    };
  }

  handleBannerClose = () => {
    this.setState({ bannerVisible: false });
    this.props.bannerVisible(false);
  };

  handleBannerClick = () => {
    const bannerLink = envConfig.banner.bannerLink;

    if (bannerLink && bannerLink.trim() !== "") {
      window.open(bannerLink, "_blank", "noopener,noreferrer");
    }
  };

  render() {
    const { bannerVisible } = this.state;
    const bannerLink = envConfig.banner.bannerLink;

    let modelStyle = {
      display: bannerVisible ? "block" : "none",
      backgroundColor: "rgba(0,0,0,0.8)",
      position: "fixed",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
    };

    return (
      <div>
        <Fragment>
          <div className="ch-notif-banner">
            <div className="banner modal show" style={modelStyle}>
              <div className="banner modal-dialog modal-width">
                <div className="banner modal-content">
                  <button
                    type="button"
                    className="banner btn-close"
                    onClick={this.handleBannerClose}
                  ></button>

                  <div className="bannermodal-body">
                    <img
                      src={BannerImageURL}
                      alt="CheckIn"
                      onClick={this.handleBannerClick}
                      style={{
                        cursor: bannerLink ? "pointer" : "default",
                      }}
                    />
                  </div>

                </div>
              </div>
            </div>
          </div>
        </Fragment>
      </div>
    );
  }
}

export default Banner;
